// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RotateLeftOutlinedSvg from "@fishx/icons-svg/es/asn/RotateLeftOutlined";
import FishxIcon from '../components/FishxIcon';

var RotateLeftOutlined = function RotateLeftOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RotateLeftOutlinedSvg
  }));
};

RotateLeftOutlined.displayName = 'RotateLeftOutlined';
export default React.forwardRef(RotateLeftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RotateLeftOutlined.js
// module id = 4039
// module chunks = 0